const License = (function () {
    'use strict'

    let overlayAjaxContent;
    let licenseDownloadButton;

    const loadHTML = (fileURL, licenseURL) => {
        $(overlayAjaxContent).load(`${licenseURL} #htmlcontent`);
        $(licenseDownloadButton).attr('href', fileURL);
        $(licenseDownloadButton).on('click', function(e) {
          Overlay.close();
          document.location.href = fileURL;
          e.preventDefault();
        })
    }

    const init = () => {
        overlayAjaxContent = $('[data-hook=overlay-ajax-content]');
        licenseDownloadButton = $('[data-hook=license-download-button]');
    }

    const show = (fileURL, licenseURL) => {
        Overlay.open();
        loadHTML(fileURL, licenseURL);
        //console.log();
    }

    const reset = () => {
        $(overlayAjaxContent).html('...');
    }

    return {
        init: init,
        show: show,
        reset: reset,
    }
})();
